// src/features/plan/DispositionPill.jsx
//
// PLAN-S1 — Small inline pill showing a disposition value with its color.
// Used in RosterView table rows and DispositionHorizonView.
// Renders nothing when disposition is null/undefined.

import React from "react";
import { T, DISPOSITION_META } from "../../app/tokens.js";

/**
 * @param {object}   props
 * @param {string?}  props.disposition  One of the 7 disposition values or null
 * @param {string}   [props.size="sm"]  "sm" | "md"
 */
export function DispositionPill({ disposition, size = "sm" }) {
  if (!disposition) return null;

  const meta = DISPOSITION_META[disposition];
  if (!meta) return null;

  const pad = size === "md" ? "3px 10px" : "2px 10px";

  return (
    <span
      data-testid="disposition-pill"
      style={{
        display:      "inline-flex",
        alignItems:   "center",
        padding:      pad,
        borderRadius: 6,
        background:   meta.bg,
        color:        meta.color,
        fontSize:     T.fsXs,
        fontWeight:   T.fwSemibold,
        whiteSpace:   "nowrap",
      }}
    >
      {meta.label}
    </span>
  );
}
